import { createApi } from "@reduxjs/toolkit/query/react";

import { baseCustomFetchBase } from "../service/customFetchBase";

const otpRecordApi = createApi({
  reducerPath: "otpRecordApi",
  baseQuery: baseCustomFetchBase,
  endpoints: (builder) => ({
    getOtpRecords: builder.query<any, any>({
      query: () => ({
        url: "otp-records",
        method: "GET",
      }),
    }),
    toggleOtpRecord: builder.mutation<any, { id: string; isShared: boolean }>({
      query: ({ id, isShared }) => ({
        url: `otp-record/${id}`,
        method: "PUT",
        body: { isShared },
      }),
    }),
  }),
});

export default otpRecordApi;

export const { getOtpRecords, toggleOtpRecord } = otpRecordApi.endpoints;
